import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { DeviceDataService } from '../_services';
import * as DeviceDataActions from '../_actions/deviceData';

@Injectable({
  providedIn: 'root',
})
export class DeviceDataEffects {
  loadDevicesData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeviceDataActions.loadDevicesData),
      mergeMap((queryData) =>
        this.deviceDataService
          .getDeviceData(
            queryData.deviceID,
            queryData.from,
            queryData.periodTo,
            queryData.limit,
            queryData.onlyImages
          )
          .pipe(
            map((devicesData) => DeviceDataActions.loadDevicesDataSuccess({ devicesData })),
            catchError((error) => of(DeviceDataActions.loadDevicesDataFailure({ error })))
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private deviceDataService: DeviceDataService
  ) {}
}
